
module.exports = {
  MODAL_PREFIX: 'modal-confirmation-'
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/constants.js